import mixpanel from "mixpanel-browser"

const token = document.querySelector('meta[name="telemetry-token"]')?.content
const userId = document.querySelector('meta[name="telemetry-user-id"]')?.content
const companyId = document.querySelector('meta[name="telemetry-company-id"]')?.content

if (token && userId && companyId) {
  mixpanel.init(token, {track_pageview: false})
  mixpanel.identify(Number(userId))
  mixpanel.set_group("company_id", Number(companyId))
  mixpanel.track_pageview({company_id: Number(companyId)})
}

const telemetry = {
  track(event, properties = {}) {
    if (token && userId && companyId) {
      mixpanel.track(event, properties)
    }
  }
}

export default telemetry
